export const PAGE_TEXT = {
  EMAIL: 'Email',
  VALID_EMAIL: 'Invalid email',
  EMAIL_VERIFICATION_CODE: 'Email Verification Code',
  EMAIL_HAS_BEEN_REGISTERED: 'Email has been registered',
  EMAIL_FORMAT_ERR: 'Incorrect email format',
  SEND_EMAIL_VERIFICATION_CODE: 'Send code',
  WAIT_FOR_RESEND_V_CODE: 'Please wait for a while',
  SEND_V_CODE_ERR: 'Server cannot send verification code',
  DUPLICATE_EMAIL: 'This email is already taken. Please try another.',
  INCORRECT_VERIFICATION_CODE: 'Incorrect verification code.',
  PASSWORD: 'Password',
  BACK_TO_LOGIN: 'Back to login',
  RESET_PASSWORD: 'Reset password',
  VALID_PASSWORD:
    'Password must be at least 8 characters long and include letters, numbers, and symbols',
  CONFIRM_PASSWORD: 'Confirm Password',
  PASSWORD_MATCH: 'The Confirm Password does not match with your Password.',
  SURNAME: 'Surname',
  GIVEN_NAME: 'Given Name',
  CHINESE_NAME: 'Name in Chinese',
  BIRTHDAY: 'Date of Birth',
  GENDER: 'Gender',
  IDENTITY_TYPE: 'Identity Type',
  NATIONALITY: 'Nationality(Country/Region)',
  PROVINCE: 'Province',
  IS_LOCAL: 'Local Indicator',
  NEED_STUDENT_VISA: 'Need Student Visa',
  VISA_TYPE_UPDATE: {
    TITLE: 'Visa Type Update:',
    CHANGE_VISA_COMPENSATION:
      'For changes to applicants who have accepted an offer:',
    CONFIRM: 'Confirm',
    CLEAR: 'Clear',
  },

  VISA_TYPE: 'Visa Type',
  VISA_COMPENSATION: {
    ADD: {
      LABEL: 'Add Visa Compensation',
      DIALOG: {
        TITLE: 'Confirmation of Add',
        CONTENT:
          'Do you confirm to add visa compensation? Once visa compensation is added, it will create a record in visa application.',
        CONFIRM_ACTION: 'Confirm',
        CANCEL_ACTION: 'Cancel',
      },
      REMINDER_CONTENT: `The information has been added successfully. To ensure all changes to the form are recorded, please click the "Update" or "Save" button at the bottom of the page.`,
      HINTS:
        'Explanation: This button means once visa compensation is added, it will create a record in visa application.',
    },
    DELETE: {
      LABEL: 'Delete Visa Compensation',
      DIALOG: {
        TITLE: 'Confirmation of Delete',
        CONTENT:
          'Do you confirm to delete visa compensation? Once visa compensation is removed, the visa application record will be removed from visa application.',
        CONFIRM_ACTION: 'Confirm',
        CANCEL_ACTION: 'Cancel',
      },
      REMINDER_CONTENT: `The item has been deleted successfully. To ensure all changes to the form are recorded, please click the "Update" or "Save" button at the bottom of the page.`,
      HINTS:
        'Explanation: This button means once visa compensation is removed, the visa application record will be removed from visa application.',
    },
    REMINDER: {
      DIALOG: {
        TITLE: 'Reminder',
        CONTENT: '',
        CONFIRM_ACTION: 'Noted, Thank You.',
      },
    },
  },
  IDENTITY_DOCUMENT_TYPE: 'Identity Document Type',
  PASSPORT_NUMBER: 'Passport Number',
  MAINLAND_IDENTITY_NUMBER: 'Mainland Identity Card Number',
  HK_IDENTITY_NUMBER: 'Hong Kong Identity Card Number',
  IDENTITY_NUMBER: 'Passport/ID Card Number',
  MOBILE_PHONE_NUMBER: 'Mobile Phone Number *',
  HOME_PHONE_NUMBER: 'Home Phone Number',
  ADDRESS: 'Address',
  ADDRESS_COUNTRY: 'Address Country/Region',
  ADDRESS_LINE_1: 'Address Line 1',
  ADDRESS_LINE_2: 'Address Line 2 (Optional)',
  ADDRESS_LINE_3: 'Address Line 3 (Optional)',
  DISABILITY_SPECIAL_EDUCATIONAL_NEEDS:
    'Disability/Special Educational Needs (if applicable)',
  DISABILITY_SPECIAL_EDUCATIONAL_NEEDS_DETAIL:
    'Disability/Special Educational Needs Detail',
  PI_DECLARATION:
    'I confirm that I have read and understood the <a href="https://www.polyu.edu.hk/aradm/eadmission/PICS_applicant.pdf" target="_blank" rel="noopener noreferrer">Personal Information Collection Statement (PICS) of PolyU</a>, <a href="http://www.polyu.edu.hk/aradm/eadmission/EEA.pdf" target="_blank" rel="noopener noreferrer">Notice for Applicants from the European Economic Area</a> and <a href="https://www.polyu.edu.hk/aradm/eadmission/PICS_for_PRC_applicant.pdf" target="_blank" rel="noopener noreferrer">Personal Information Protection Law (PIPL) of PRC</a>. *',
  REQUIRED: 'Required',
  CHINESE_NAME_REQUIRED: 'Valid Chinese name is required',
  BACK: 'Back',
  SAVE: 'Save',
  NEXT: 'Next',
  SUBMIT: 'Submit',
  ALREADY_HAVE_AN_ACCOUNT: 'Already have an account?',

  SIGNUP_FAILED: 'Signup failed.',

  OPTIONS_LABEL: {
    GENDER: {
      FEMALE: 'Female',
      MALE: 'Male',
    },
    IDENTITY_DOCUMENT_TYPE: {
      HK_ID: 'Hong Kong Identity Card',
      MAINLAND_ID: 'Mainland Identity Card',
      PASSPORT: 'Passport',
    },
    IDENTITY_TYPE: {
      HK_PERMANENT_ID_CARD: 'HK Permanent ID Card',
      STUDENT_VISA: 'Student Visa',
      OTHERS: 'Others',
      HINT: 'What kind of identity document will you hold at the commencement of your study at PolyU?',
      IANG: 'An entry permit for IANG (Immigration Arrangements for Non-local Graduates)',
      DEPENDANT_VISA_BELOW_18:
        'A valid dependant visa (My dependant visa was first issued when I was below 18 years old.)',
      DEPENDANT_VISA_ABOVE_18:
        'A valid dependant visa (My dependant visa was first issued when I was above 18 years old.)',
      ONE_WAY_PERMIT:
        'One-way permit for entry to Hong Kong (中華人民共和國前往港澳通行證)',
      QUALITY_MIGRANT_ADMISSION_SCHEME:
        'Visa/Entry permit for Quality Migrant Admission Scheme (優秀人才入境計劃)',
      CAPITAL_INVESTMENT_ENTRANT_SCHEME:
        'Visa/Entry permit for Capital Investment Entrant Scheme (資本投資者入境計劃)',
      ADMISSION_SCHEME_FOR_THE_SECOND_GENERATION:
        'Visa/Entry permit for Admission Scheme for the Second Generation of Chinese Hong Kong Permanent Residents (輸入中國籍香港永久性居民第二代計劃)',
      VISA_LABEL_FOR_UNCONDITIONAL_STAY:
        'Visa label for unconditional stay (無條件限制逗留)',
      RECOGNIZANCE_FORM_HOLDERS: 'Recognizance Form Holders',
      FULL_TIME_EMPLOYMENT_VISA_WORK_PERMIT:
        'Full-time employment visa/work permit for working in Hong Kong (excluding IANG)',
      HK_ID_WITH_RIGHT_LANDING_HONG_KONG:
        'A Hong Kong ID Card with the right to land in Hong Kong',
      DEPENDANT_VISA_UNDER_18:
        'A valid dependant visa (My dependant visa was first issued when I was below 18 years old.)',
      HKID_PERM: 'HK Permanent ID Card',
      TTPS: 'A visa/entry permit for TTPS (under the Top Talent Pass Scheme)',
      HKID_RIGHT_TO_LAND:
        'A Hong Kong ID Card with the right to land in Hong Kong',
      WORK_VISA:
        'Full-time employment visa/work permit for working in Hong Kong (excluding IANG)',
      OTHER_VISA: 'Other visa types',
    },
    IDENTITY_TYPE_FULL_OPTIONS: {
      HKID_PERM: 'Hong Kong Permanent Identity Card',
      STUDENT_VISA: 'Student Visa',
      IANG: 'An entry permit for IANG (Immigration Arrangements for Non-local Graduates)',
      WORK_VISA:
        'Full-time employment visa/work permit for working in Hong Kong (excluding IANG)',
      QUALITY_MIGRANT_ADMISSION_SCHEME:
        'Visa/Entry permit for Quality Migrant Admission Scheme (優秀人才入境計劃)',
      ONE_WAY_PERMIT:
        'One-way permit for entry to Hong Kong (中華人民共和國前往港澳通行證)',
      CAPITAL_INVESTMENT_ENTRANT_SCHEME:
        'Visa/Entry permit for Capital Investment Entrant Scheme (資本投資者入境計劃)',
      ADMISSION_SCHEME_FOR_THE_SECOND_GENERATION:
        'Visa/Entry permit for Admission Scheme for the Second Generation of Chinese Hong Kong Permanent Residents (輸入中國籍香港永久性居民第二代計劃)',
      TTPS: 'A visa/entry permit for TTPS (under the Top Talent Pass Scheme)',
      HKID_RIGHT_TO_LAND:
        'A Hong Kong ID Card with the right to land in Hong Kong',
      VISA_LABEL_FOR_UNCONDITIONAL_STAY:
        'Visa label for unconditional stay (無條件限制逗留)',
      DEPENDANT_VISA_BELOW_18:
        'A valid dependant visa (My dependant visa was first issued when I was below 18 years old.)',
      DEPENDANT_VISA_ABOVE_18:
        'A valid dependant visa (My dependant visa was first issued when I was above 18 years old.)',
      RECOGNIZANCE_FORM_HOLDERS: 'Recognizance Form Holders',
      OTHER_VISA: 'Other visa types',
      NO_VISA: 'No visa required',
    },
    IS_LOCAL: {
      LOCAL: 'Local',
      NON_LOCAL: 'Non-local',
    },
    NEED_STUDENT_VISA: {
      YES: 'Yes',
      NO: 'No',
    },
    DISABILITY_SPECIAL_EDUCATIONAL_NEEDS_TYPE: {
      ATTENTION_DEFICIT_HYPERACTIVITY_DISORDER:
        'Attention deficit / Hyperactivity disorder',
      AUTISM: 'Autism',
      HEARING_IMPAIRMENT: 'Hearing impairment',
      LEARNING_DISORDER: 'Learning Disorder (Specific Learning Difficulties)',
      MENTAL_ILLNESS: 'Mental illness',
      PHYSICAL_DISABILITY: 'Physical disability',
      SPEECH_IMPAIRMENT: 'Speech Impairment',
      VISCERAL_DISABILITY_CHRONIC_ILLNESS:
        'Visceral disability / Chronic illness',
      VISUAL_IMPAIRMENT: 'Visual impairment',
      MULTIPLE_TYPES_OF_DISABILITIES: 'Multiple types of disabilities',
      INTELLECTUAL_DISABILITY: 'Intellectual disability',
      OTHERS: 'Others',
    },

    PROVINCE: {
      AN_HUI: 'Anhui',
      BEI_JING: 'Beijing',
      CHONG_QING: 'Chongqing',
      FU_JIAN: 'Fujian',
      GUANG_DONG: 'Guangdong',
      GAN_SU: 'Gansu',
      GUANG_XI: 'Guangxi',
      GUI_ZHOU: 'Guizhou',
      HE_NAN: 'Henan',
      HU_BEI: 'Hubei',
      HE_BEI: 'Hebei',
      HAI_NAN: 'Hainan',
      HEI_LONG_JIANG: 'Heilongjiang',
      HU_NAN: 'Hunan',
      JI_LIN: 'Jilin',
      JIANG_SU: 'Jiangsu',
      JIANG_XI: 'Jiangxi',
      LIAO_NING: 'Liaoning',
      NEI_MONGOL: 'Nei Mongol',
      NING_XIA: 'Ningxia',
      QING_HAI: 'Qinghai',
      SI_CHUAN: 'Sichuan',
      SHAN_DONG: 'Shandong',
      SHANG_HAI: 'Shanghai',
      SHAAN_XI: 'Shaanxi',
      SHAN_XI: 'Shanxi',
      TIAN_JIN: 'Tianjin',
      XIN_JIANG: 'Xinjiang',
      XI_ZANG: 'Xizang',
      YUN_NAN: 'Yunnan',
      ZHE_JIANG: 'Zhejiang',
    },
  },

  ACCOUNT_INFO: 'Account Info',
  PERSONAL_INFO: 'Personal Info',

  THANKS_SIGNUP: 'Thank you for signing up.',
  GLAD_TO_SEE: 'We are happy to see you here.',
  LOGIN_NOW: 'Login Now',

  IDENTITY_FLOW: {
    QUESTIONS: [
      '1. An entry permit for Immigration Arrangements for Non-local Graduates (IANG)?',
      '2. A valid dependant visa?',
      '3. Any of the following visa/entry permits:',
      '4. A Top Talent Pass Scheme (TTPS)?',
      '5. Full-time employment visa/work permit for working in Hong Kong (excluding IANG)?',
      '6. A Hong Kong ID Card with the right to land in Hong Kong?',
    ],
    IANG: {
      DESC: 'You are considered as a non-local applicant but you do not need to apply for a student visa to study in Hong Kong.',
    },
    DEPENDANT_VISA: {
      BELOW_18: {
        LABEL:
          'My dependant visa was first issued when I was below 18 years old.',
        DESC: 'You are considered as a local applicant and do not need a student visa to study in Hong Kong.',
      },
      ABOVE_18: {
        LABEL:
          'My dependant visa was first issued when I was above 18 years old.',
        DESC: 'You are considered as a non-local applicant but you do not need to apply for a student visa to study in Hong Kong.',
      },
    },
    OTHER_PERMITS: {
      LABELS: [
        'HKSAR Document of Identity for Visa Purposes (香港特別行政區簽證身份書)',
        'Visa/Entry permit for Quality Migrant Admission Scheme (優秀人才入境計劃)',
        'Visa/Entry permit for Capital Investment Entrant Scheme (資本投資者入境計劃)',
        'Visa/Entry permit for Admission Scheme for the Second Generation of Chinese Hong Kong Permanent Residents (輸入中國籍香港永久性居民第二代計劃)',
        'Visa label for unconditional stay (無條件限制逗留)',
      ],
      DESC: 'You are considered as a local applicant and you do not need a student visa to study in Hong Kong.',
    },
    EMPLOYMENT_PERMIT: {
      DESC: 'You are considered as a local applicant and you do not need a student visa to study a part-time programme in Hong Kong. Applicants holding full-time employment visa/work permit are normally not allowed to study a full-time programme. For enquiries, please contact the programme hosting department concerned.',
    },
    RIGHT_TO_LAND: {
      DESC: 'You are considered as a local applicant and you do not need a student visa to study in Hong Kong.',
    },
    NONE: 'Please check with Immigration Department whether you require a student visa for studying in Hong Kong https://www.immd.gov.hk/eng/services/visas/study.html',
  },

  UPDATE: 'Update',
  HELPER_TEXT: {
    EXPLANATION: 'Explanation',
    POINTS_TO_NOTE: 'Points to Note',
    NOTE_1: `Your residential status cannot be changed after account activation.
    It is therefore important for you to indicate your visa status correctly. If you have any doubt on your residential status, please contact the Immigration Department of the Hong Kong SAR for clarification.`,
    NOTE_2: `The levels of tuition fees for local and non-local students are different for some programmes. If your status changes from non-local to local or vice versa after you submit your application, any offers made under the initial admissions scheme may be cancelled and your application will be considered in competition with other eligible applicants under the subsequent admissions scheme. Any fees paid will not be refunded.`,
    HK_PERMANENT_ID_CARD: {
      CONTENT_REQUIRED: `Please ensure that your Hong Kong ID Card contains the word "Permanent" in the title. If no, please click 'Others'.`,
    },
    STUDENT_VISA: {
      CONTENT_REQUIRED: `Please ensure that you are not holding a Hong Kong SAR passport and you require a student visa to study in Hong Kong.`,
    },
  },
};
